import MiniLobby from "component/lobby/MiniLobby";
import LobbyGameNavigation from "component/lobby/GameNavigation";

export { MiniLobby, LobbyGameNavigation };

export default Object.assign({
  MiniLobby,
  LobbyGameNavigation,
});
